import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { useEffect, useState } from 'react'
import '../style/ChoosePayMehod/ChoosePayMethod.scss'
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import md5 from 'md5';
import axios from 'axios';
import { setIdContratto, setPayMethodDefault } from '../features/userSlice';
import {ReactComponent as Bank} from '../assets/new-icons/bank2.svg';
import {ReactComponent as Check} from '../assets/new-icons/check_circle.svg';
import {ReactComponent as More} from '../assets/new-icons/plus.svg';
import {ReactComponent as Card} from '../assets/new-icons/card.svg';

function ChoosePayMethod() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const customerId = useSelector((user) => user.user.info.customer_id)
    const token = useSelector((user) => user.user.datiPagamento.token)
    const iban = useSelector((user) => user.user.datiPagamento.account_iban)
    const defaultMethod = useSelector((user) => user.user.payMethodDefault)
    const [ibans, setIbans] = useState([])
    const [cards, setCards] = useState()
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const idContratto = useSelector((user) => user.user.idContratto)
    
    useEffect(() => {
        setIbans([{iban}])
        if(token){
            getCard()
        }
        getMethod()
    },[token, iban])

    const getCard = async () => {
        const apiCard = `https://my.revoluce.it/area_utente/gestione/api/customers/getCarte.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(apiCard)
        setCards(data)
    }
    const getMethod = async () => {
        const apiMethod = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMetodiPagamento.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(apiMethod)
        dispatch(setPayMethodDefault(data.dati.metodo_predefinito))
        setCards(data.dati.dati_token)
        dispatch(setIdContratto(data.dati.id_contratto))
    }
    const selectMethodIban = async (props) => {
        const methodUrl = `https://my.revoluce.it/area_utente/gestione/api/faidate/setMetodoPagamento.php?customer_id=${customerId}&tkn_pvt=${tkn}&id_metodo=17&id_contratto=${idContratto}&id_token=id`
        const { data } = await axios.get(methodUrl)
        getMethod()

    }
    const selectMethodToken = async (props) => {
        const methodUrl = `https://my.revoluce.it/area_utente/gestione/api/faidate/setMetodoPagamento.php?customer_id=${customerId}&tkn_pvt=${tkn}&id_metodo=20&id_contratto=${idContratto}&id_token=${props.id}`
        const { data } = await axios.get(methodUrl)
        getMethod()
    }
 
    return (
        <div className='choosePayMethod'>
            <div className="header">
                <div className="container">
                    <div className="icon" onClick={() => navigate(-1)}>
                        <ArrowBackIcon />
                    </div>
                    <p className='label epilogue'>Pagamento</p>
                </div>
            </div>
            <div className="body">
                <p className="main">Cambia o aggiungi metodo di pagamento</p>
                <p className="secondary">
                    Collega il tuo conto o la tua carta per assicurarti il miglior prezzo.
                </p>
                {ibans && ibans.map((iban, i) => (
                    <div key={i} className={`method ${defaultMethod === 'RID' ? 'active' : null}`} onClick={() => selectMethodIban(iban)}>
                        <div className="iconBox">
                            <Bank />
                        </div>
                        <div className="text">
                            <p className="secondary">Iban:</p>
                            <p className='main bold'>********* </p>
                        </div>
                        {defaultMethod && defaultMethod === 'RID' ? (
                            <div className="check">
                                <Check/>
                            </div>
                        ) : null}
                        
                    </div>
                ))}
                {cards && cards.map((card, i) => (
                    <div key={i} className={`method ${defaultMethod !== 'RID' && card.token_default === '1' ? 'active' : null}`} onClick={() => selectMethodToken(card)}>
                        <div className="iconBox">
                            <Card />
                        </div>
                        <div className="text">
                            <p className='secondary'>Carta di credito</p>
                            <p className='main bold'>**** **** **** </p>
                        </div>
                        {
                            defaultMethod !== 'RID' && card.token_default === '1' ? (
                                <div className="check">
                                    <Check/>
                                </div>
                            ) : null
                        }
                            
                    </div>
                ))}
                <div className="addNewMethod" onClick={() => navigate('/enrica/profilo/aggiungi')}>
                    <div className="iconBox">
                        <More />
                    </div>
                    <div className="text">
                        <p className='main bold'>Aggiungi nuovo metodo</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChoosePayMethod
